var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-box',{attrs:{"title":"关于我","line-color":"#2D99AE","id":"oak_as_me"}},[_c('span',{staticStyle:{"font-size":"17px"}},[_vm._v("我就是我，颜色不一样的烟火~")])])}
var staticRenderFns = []

export { render, staticRenderFns }